import React, { useState, useEffect, useRef } from "react";
import { MDBRow, MDBCol, MDBContainer } from "mdb-react-ui-kit";
import axios from "axios";
// config
import configData from "../../../config/config.json";
// omponents
import MetaTagsBusinessOwners from "../../../components/meta-tags-seo/MetaTagsBusinessOwners";
import Sidbarbusiness from "../../../components/business-dashboard/sidbar/Sidbarbusiness";
import HeaderMobile from "../../../components/business-dashboard/sidbar/HeaderMobile";
import Collapse from "../../../components/business-dashboard/Collapse/Collapse";

//components for 8 steps
import InformationStep1 from "../../../components/business-dashboard/business-information-steps/InformationStep1";
import InformationStep2 from "../../../components/business-dashboard/business-information-steps/InformationStep2";
import InformationStep2b from "../../../components/business-dashboard/business-information-steps/InformationStep2b";
import InformationStep3 from "../../../components/business-dashboard/business-information-steps/InformationStep3";
import InformationStep4 from "../../../components/business-dashboard/business-information-steps/InformationStep4";
import InformationStep5 from "../../../components/business-dashboard/business-information-steps/InformationStep5";
import InformationStep6 from "../../../components/business-dashboard/business-information-steps/InformationStep6";
import InformationStep7 from "../../../components/business-dashboard/business-information-steps/InformationStep7";
import InformationStep8 from "../../../components/business-dashboard/business-information-steps/InformationStep8";

const BusinessInformation = (props) => {
  const [render, setRender] = useState(false);

  // this 2 satae for Meta Tags
  const [MTagsCome, setMTagsCome] = useState(false);
  const [MetaData, setMetaData] = React.useState({});

  const { state } = props.location; // to open Description collapse
  const scrollToRef = useRef(null); // to scroll to Description collapse

  //api header
  const headerMeta = {
    ApiKey: "87e4d3a91a554a2196ae8bdf0bfdcdc9",
    LangId: 1,
    Page: "business-information",
  };

  useEffect(() => {
    let OwnerIdCookie = getCookie("OwnerId");
    if (!OwnerIdCookie) {
      props.history.push({
        pathname: "/login",
      });
    } else if (render) {
      axios
        .get(configData.API_DOMAIN + "/api/v1/MetaTags/businessOwner", {
          headers: headerMeta,
        })
        .then((response) => {
          if (response.data.isSuccess) {
            setMTagsCome(true);
            setMetaData(response.data.data);
          }
        })
        .catch((error) => {
          // alert(error);
        });
    }

    if (state) {
      scrollToRef.current.scrollIntoView();
    }
  }, [render]);

  //   getCookie
  function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  let windowWidth = "00";
  if (typeof window !== "undefined") {
    // Code that relies on the window object
    windowWidth = window.innerWidth;
  } else {
    windowWidth = "00";
  }

  return (
    <>
      {MTagsCome ? <MetaTagsBusinessOwners data={MetaData} /> : ""}

      {windowWidth < 768 ? <HeaderMobile setRender={setRender} /> : ""}
      <div className="margin-0 d-flex bg_business_grey">
        <div className="  d-none d-md-block">
          {windowWidth > 767 ? <Sidbarbusiness setRender={setRender} /> : ""}
        </div>
        <MDBContainer className="bg_business_grey">
          <MDBRow>
            <MDBCol size="12">
              <div>
                <p className="text_img_bus">اطلاعات کسب‌و‌کار</p>
              </div>

              <InformationStep1 render={render} />

              <Collapse header={"ثبت مالکیت"} open={false}>
                <InformationStep2 />
              </Collapse>
              <Collapse header={"عنوان کسب‌و‌کار"} open={false}>
                <InformationStep2b />
              </Collapse>
              <div ref={scrollToRef}></div>
              <Collapse header={"معرفی کسب‌و‌کار"} open={state ? true : false}>
                <InformationStep3 />
              </Collapse>
              <Collapse header={"انتخاب دسته‌بندی کسب‌وکار"} open={false}>
                <InformationStep4 />
              </Collapse>
              <Collapse header={"امکانات"} open={false}>
                <InformationStep5 />
              </Collapse>
              <Collapse header={"آدرس"} open={false}>
                <InformationStep6 />
              </Collapse>
              <Collapse header={"اطلاعات تماس و سوشال مدیا"} open={false}>
                <InformationStep7 />
              </Collapse>
              <Collapse header={"روزها و ساعات کاری"} open={false}>
                <InformationStep8 />
              </Collapse>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </div>
    </>
  );
};

export default BusinessInformation;
